import { cn } from "@tine/designsystem-utils";

import type { ContentfulUsp } from "../../../common/types/cmsTypes";
import Usp from "./Usp";

type UspListProps = {
   uspList: ContentfulUsp[];
   contentType: string;
   trackingListName: string;
};

const UspList = ({ uspList, contentType, trackingListName }: UspListProps) => {
   // A USP list should always have either 3 or 4 USPs
   const threeUsps = uspList.length === 3;
   const fourUsps = uspList.length === 4;

   const uspListClasses = cn("relative flex flex-col items-center justify-between gap-4 lg:flex-row lg:gap-8 lg:py-8", {
      "xl:px-12": threeUsps,
      "xl:px-10": fourUsps
   });

   if (uspList.length > 4 || uspList.length < 3) {
      return null;
   }

   return (
      <div className={uspListClasses}>
         {uspList.map((usp) => {
            return (
               <Usp
                  key={usp.sys.id}
                  usp={usp}
                  threeUsps={threeUsps}
                  fourUsps={fourUsps}
                  trackingListName={trackingListName}
                  contentType={contentType}
               />
            );
         })}
      </div>
   );
};

export default UspList;
